import {
    CONFIRM_FARE,
    CONFIRM_FARE_SUCCESS,
    CONFIRM_FARE_FAILED,
    FETCH_ALL_FARE,
    FETCH_ALL_FARE_SUCCESS,
    FETCH_ALL_FARE_FAILED,
    CLEAR_FARE,
    EDIT_FARE,
    EDIT_FARE_SUCCESS,
    EDIT_FARE_FAILED,
    UPDATE_FARE
} from "../store/types";
import { cloud_function_server_url } from '../../config';

const END_POINT = `${cloud_function_server_url}/fare`;

export const clearFare = (id) => (dispatch) => (firebase) => {

    fetch(`${END_POINT}/delete-fare/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then(async (res) => {
            fetchFare()(dispatch)(firebase)
        }).catch(error => {
            console.log("res check error", error)
        });
}

export const addLocalFare = (fareData) => (dispatch) => (firebase) => {

    dispatch({
        type: CONFIRM_FARE,
        payload: fareData,
    });

    var data = {
        carType: fareData.carType,
        fareType: fareData.fareType,
        tripType: fareData.tripType,
        tripStartKM: fareData.tripStartKM,
        tripEndKM: fareData.tripEndKM,
        fare: fareData.fare,
    }

    fetch(`${END_POINT}/add-local-fare`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    })
        .then(async (res) => {
            const response = await res.json();
            dispatch({
                type: CONFIRM_FARE_SUCCESS,
                payload: {
                    fare_id: response.data?._id,
                    mainData: data,
                }
            });
            fetchFare()(dispatch)(firebase)
        }).catch(error => {
            console.log("res check error", error)
            dispatch({
                type: CONFIRM_FARE_FAILED,
                payload: error,
            });
        });
};

export const addRentalFare = (fareData) => (dispatch) => (firebase) => {

    dispatch({
        type: CONFIRM_FARE,
        payload: fareData,
    });

    var data = {
        carType: fareData.carType,
        fareType: fareData.fareType,
        tripType: fareData.tripType,
        tripKM: fareData.tripKM,
        tripHours: fareData.tripHours,
        afterPerKM: fareData.afterPerKM,
        afterPerMin: fareData.afterPerMin,
        fare: fareData.fare,
    }

    fetch(`${END_POINT}/add-rental-fare`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    })
        .then(async (res) => {
            const response = await res.json();
            dispatch({
                type: CONFIRM_FARE_SUCCESS,
                payload: {
                    fare_id: response.data?._id,
                    mainData: data,
                }
            });
            fetchFare()(dispatch)(firebase)
        }).catch(error => {
            console.log("res check error", error)
            dispatch({
                type: CONFIRM_FARE_FAILED,
                payload: error,
            });
        });
};

export const addOutstationFare = (fareData) => (dispatch) => (firebase) => {

    dispatch({
        type: CONFIRM_FARE,
        payload: fareData,
    });

    var data = {
        carType: fareData.carType,
        fareType: fareData.fareType,
        tripType: fareData.tripType,
        dayTrip: fareData.dayTrip,
        tripKM: fareData.tripKM,
        tripHours: fareData.tripHours,
        tripMinutes: fareData.tripMinutes,
        fare: fareData.fare,
    }

    fetch(`${END_POINT}/add-outstation-fare`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    })
        .then(async (res) => {
            const response = await res.json();
            dispatch({
                type: CONFIRM_FARE_SUCCESS,
                payload: {
                    fare_id: response.data?._id,
                    mainData: data,
                }
            });
            fetchFare()(dispatch)(firebase)
        }).catch(error => {
            console.log("res check error", error)
            dispatch({
                type: CONFIRM_FARE_FAILED,
                payload: error,
            });
        });
};

export const updateFare = (fareData) => (dispatch) => (firebase) => {
    console.log("update fate", fareData)
    const data = { ...fareData }
    delete data._id;
    delete data.__v;
    console.log("update delete", data, fareData)

    dispatch({
        type: UPDATE_FARE,
        payload: fareData
    });

    fetch(`${END_POINT}/update-fare/${fareData._id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data })
    })
        .then(async (res) => {
            dispatch({
                type: EDIT_FARE_SUCCESS,
                payload: null
            });
            fetchFare()(dispatch)(firebase)
        }).catch(error => {
            console.log("res check error", error)
            dispatch({
                type: EDIT_FARE_FAILED,
                payload: error
            });
        });
};


export const fetchFare = () => (dispatch) => (firebase) => {

    dispatch({
        type: FETCH_ALL_FARE,
        payload: null,
    });

    fetch(`${END_POINT}/fetch-fares`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then(async (res) => {
            const response = await res.json();
            dispatch({
                type: FETCH_ALL_FARE_SUCCESS,
                payload: {
                    fare: response.data,
                    active: [],
                },
            });
        }).catch(error => {
            console.log("res check error", error)
            dispatch({
                type: FETCH_ALL_FARE_FAILED,
                payload: "No Fare",
            });
        });
};

export const getFare = (startRange, endRange, tripType, fairType, firebase) => {
    const {
        fareListRef,
    } = firebase;

    var result = [];
    fareListRef.on("value", (snapshot) => {
        if (snapshot.val()) {
            const data = snapshot.val();
            const fare = Object.keys(data)
                .map((i) => {
                    data[i].id = i;
                    return data[i];
                });
            result = fare.filter(item => item.tripStartKM === startRange && item.tripEndKM === endRange && item.tripType === tripType && item.fairType === fairType);
        }
    });

    return result;
};
